import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { CaretUpDown, Check, CircleNotch, Package } from "@phosphor-icons/react";

// Jun 25 2026, user's ask: "add consume item's which are available in the
// respected warehouse & Site... site P1, department P1-HDG, show all
// available item for consumption". So the first thing a head sees is what is
// actually lying in his own godown, with SAP's quantity and unit - not the
// whole product master.
export const StockItemPicker = ({ stock, mappedProductIds, onPick, busy, testIdPrefix }) => {
  const [open, setOpen] = useState(false);
  const items = stock?.items || [];
  const unmapped = items.filter((i) => !mappedProductIds.includes(i.product_id));

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          disabled={busy || items.length === 0}
          className="h-9 w-full flex items-center justify-between px-3 rounded-md border border-[#0E7C86] bg-[#F0FDFA] text-sm text-left disabled:opacity-50 hover:bg-[#CCFBF1] transition-colors duration-150"
          data-testid={`${testIdPrefix}-stock-trigger`}
        >
          <span className="text-[#0B6B74] font-semibold flex items-center gap-2 truncate">
            {busy ? <CircleNotch size={14} className="animate-spin" /> : <Package size={14} weight="fill" />}
            {items.length === 0
              ? `No consumables in stock in ${stock?.logistics_area_id || "this godown"}`
              : `Add from ${stock.logistics_area_id} stock (${unmapped.length} available)`}
          </span>
          <CaretUpDown size={13} className="text-[#0B6B74] shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[min(420px,calc(100vw-32px))] p-0" align="start">
        <Command>
          <CommandInput placeholder="Filter this godown..." data-testid={`${testIdPrefix}-stock-input`} />
          <CommandList>
            <CommandEmpty>Nothing here matches.</CommandEmpty>
            <CommandGroup heading={`Consumables in ${stock?.logistics_area_id || ""}`}>
              {items.map((item) => {
                const already = mappedProductIds.includes(item.product_id);
                return (
                  <CommandItem
                    key={item.product_id}
                    value={`${item.product_id} ${item.description || ""}`}
                    onSelect={() => { if (!already) { onPick(item); setOpen(false); } }}
                    className={already ? "opacity-60" : ""}
                    data-testid={`${testIdPrefix}-stock-option-${item.product_id}`}
                  >
                    <div className="flex-1 min-w-0">
                      <div className="text-xs">
                        <span className="font-mono font-bold text-[#101828]">{item.product_id}</span>
                        <span className="text-[#667085]"> · {item.description || "—"}</span>
                      </div>
                      <div className="text-[11px] text-[#667085]">
                        {item.qty?.toLocaleString("en-IN")} {item.uom} in stock{already ? " · already mapped here" : ""}
                      </div>
                    </div>
                    {already && <Check size={14} weight="bold" className="text-[#0E7C86] shrink-0" />}
                  </CommandItem>
                );
              })}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
